import {SxType} from '@baseTypes/sx/sxTypes'

const ACCENT = 'var(--account-accent, #0C6DDF)'
const ACCENT_CONTRAST = 'var(--account-accent-contrast, #fff)'

export default {
	title: {
		fontWeight: 700,
		textAlign: 'center',
	},
	tabs: {
		display: 'grid',
		gridTemplateColumns: {
			xs: 'repeat(2, 1fr)',
			md: 'none',
		},
		gridAutoFlow: {
			md: 'column',
		},
		gridAutoColumns: '1fr',
		width: {
			md: 'fit-content',
		},
		mx: 'auto',
		gap: '2px',
		p: '4px',
		mb: 3,
		flexShrink: 0,
		borderRadius: '12px',
		border: '1px solid',
		borderColor: 'divider',
		'.lightTheme &': {
			backgroundColor: '#fff',
		},
		'.darkTheme &': {
			backgroundColor: 'rgba(255, 255, 255, 0.04)',
		},
	},
	tab: {
		width: '100%',
		justifyContent: 'center',
		textAlign: 'center',
		whiteSpace: {
			md: 'nowrap',
		},
		gap: '6px',
		padding: '6px 14px',
		borderRadius: '9px',
		textTransform: 'none',
		fontSize: '14px',
		fontWeight: 600,
		lineHeight: 1.25,
		color: 'text.secondary',
		transition: 'background-color .2s, color .2s',
		'&:hover': {
			backgroundColor: 'var(--account-accent-soft, rgba(12, 109, 223, 0.08))',
			color: 'text.primary',
		},
		'&.active, &.active:hover': {
			backgroundColor: ACCENT,
			color: ACCENT_CONTRAST,
		},
	},
	tabIconWrap: {
		flexShrink: 0,
		display: 'flex',
		alignItems: 'center',
		'& .MuiSvgIcon-root': {
			fontSize: '18px',
			color: ACCENT,
		},
		'.active & .MuiSvgIcon-root': {
			color: ACCENT_CONTRAST,
		},
	},
} as const satisfies SxType
